import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import VerifyCode from "pages/Authentication/VerifyOTP"
import ResetPassword from "pages/Authentication/ResetPassword"
import StaffIndex from "pages/Staff"
import StaffDevices from "pages/StaffDevices"
import RolesIndex from "pages/Roles"
import Holiday from "pages/LeavesModule/Holiday"
import Leaves from "pages/LeavesModule/Leaves"
import LeadsIndex from "pages/Leads"
import EditLead from "pages/Leads/EditLeads"
import AddLead from "pages/Leads/AddLeads"
import ColdCallingIndex from "pages/ColdCalling"
import AddColdCall from "pages/ColdCalling/AddColdCall"
import EditColdCall from "pages/ColdCalling/EditColdCall"
import LocationTracking from "pages/LocationTracking/locationtrack"
import SalarySlip from "pages/SalarySlip"
import OpportunitiesIndex from "pages/opportunities/OpportunitiesIndex"
import Expense from "pages/SalarySlip/Expense"
import Allowance from "pages/SalarySlip/Allowances"
import PunchDetails from "pages/SalarySlip/PunchDetails"
import ViewLead from "pages/Leads/ViewLeads"
import SalarySheet from "pages/SalarySheet"
import PunchMain from "pages/SalarySlip/PunchMain"
import Advance from "pages/Advance"
import PaidOff from "pages/PaidOff"
import Equipement from "pages/Equipment"
import LeadSource from "pages/leadSource"
import TaskStatus from "pages/TaskStatus"
import Departments from "pages/Departments"
import Priorities from "pages/Priorities"
import TaskManagement from "pages/TaskManagement"
import WATemplates from "pages/WATemplates"
import WhatsAppCampaign from "pages/WhatsAppCampaign"
import WhatsAppContacts from "pages/WhatsAppContacts"
import WhatsAppGroups from "pages/WhatsAppGroups"

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },

  // Staff Module
  { path: `${Configs.appurl}staff`, component: <StaffIndex /> },
  { path: `${Configs.appurl}staff-devices`, component: <StaffDevices /> },

  // Roles Module
  { path: `${Configs.appurl}roles`, component: <RolesIndex /> },

  // Holiday Module
  { path: `${Configs.appurl}holiday`, component: <Holiday /> },

  // Leaves Module
  { path: `${Configs.appurl}leaves`, component: <Leaves /> },

  // Leads Module
  { path: `${Configs.appurl}leads`, component: <LeadsIndex /> },
  { path: `${Configs.appurl}leads/add`, component: <AddLead /> },
  { path: `${Configs.appurl}leads/edit/:id`, component: <EditLead /> },
  { path: `${Configs.appurl}leads/view/:id`, component: <ViewLead /> },

  // Opprtunity Module
  { path: `${Configs.appurl}opprtunity`, component: <OpportunitiesIndex /> },

  // Cold Calling Module
  { path: `${Configs.appurl}cold-calling`, component: <ColdCallingIndex /> },
  { path: `${Configs.appurl}cold-calling/add`, component: <AddColdCall /> },
  {
    path: `${Configs.appurl}cold-calling/edit/:id`,
    component: <EditColdCall />,
  },

  // Location Tracking Module
  { path: `${Configs.appurl}location-track`, component: <LocationTracking /> },

  // Salary Slip Module
  { path: `${Configs.appurl}salary-slip`, component: <SalarySlip /> },

  // Employee Expense Module
  { path: `${Configs.appurl}emp-expenses`, component: <Expense /> },

  // Allowances Module
  { path: `${Configs.appurl}allowances`, component: <Allowance /> },

  // Punch Details Module
  { path: `${Configs.appurl}punches`, component: <PunchMain /> },
  { path: `${Configs.appurl}punch-details/:id`, component: <PunchDetails /> },

  // Salary Sheet Module
  { path: `${Configs.appurl}salary-sheet`, component: <SalarySheet /> },

  // Advance Module
  { path: `${Configs.appurl}emp-advance`, component: <Advance /> },

  // PaidOff Module
  { path: `${Configs.appurl}paidoff`, component: <PaidOff /> },

  // PaidOff Module
  { path: `${Configs.appurl}equipment-category`, component: <Equipement /> },
  { path: `${Configs.appurl}lead-source`, component: <LeadSource /> },
  { path: `${Configs.appurl}task-status`, component: <TaskStatus /> },
  { path: `${Configs.appurl}departments`, component: <Departments /> },
  { path: `${Configs.appurl}priorities`, component: <Priorities /> },
  { path: `${Configs.appurl}task-management`, component: <TaskManagement /> },
  { path: `${Configs.appurl}wa-templates`, component: <WATemplates /> },
  {
    path: `${Configs.appurl}whatsapp-campaign`,
    component: <WhatsAppCampaign />,
  },
  {
    path: `${Configs.appurl}whatsapp-contacts`,
    component: <WhatsAppContacts />,
  },
  {
    path: `${Configs.appurl}whatsapp-groups`,
    component: <WhatsAppGroups />,
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="login" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}verify-code`, component: <VerifyCode /> },
  { path: `${Configs.appurl}reset-password`, component: <ResetPassword /> },
]

export { authProtectedRoutes, publicRoutes }
